import React from "react";

const ProfileIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8 16.5C13.8 14.1427 10.9349 12.2333 7.4 12.2333C3.86507 12.2333 1 14.1427 1 16.5M7.4 9.03333C6.26841 9.03333 5.18317 8.58381 4.38301 7.78366C3.58286 6.9835 3.13333 5.89826 3.13333 4.76667C3.13333 3.63508 3.58286 2.54983 4.38301 1.74968C5.18317 0.949522 6.26841 0.5 7.4 0.5C8.53159 0.5 9.61683 0.949522 10.417 1.74968C11.2171 2.54983 11.6667 3.63508 11.6667 4.76667C11.6667 5.89826 11.2171 6.9835 10.417 7.78366C9.61683 8.58381 8.53159 9.03333 7.4 9.03333Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ProfileIcon;
